import usePage from "../../hooks/usePage";
import FooterPostup from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import MessageGrid from "./components/MessageGrid";

function MessagePage() {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <>
      <Menu />
      {pageSliders}

      {pageText}

      <MessageGrid />

      {pageImage}
      <FooterPostup />
    </>
  );
}

export default MessagePage;
